import { render, staticRenderFns } from "./gj-carousel.vue?vue&type=template&id=19f288fc&scoped=true&"
import script from "./gj-carousel.vue?vue&type=script&lang=js&"
export * from "./gj-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f288fc",
  null
  
)

export default component.exports